import { APP_ENVIRONMENT } from '../global';
import { ModuleIdMappingProd } from './modules.prod';
import { ModuleIdMappingQa } from './modules.qa';

export const ModuleConstants = {
  ...(APP_ENVIRONMENT === 'production'
    ? ModuleIdMappingProd
    : ModuleIdMappingQa),
};
